module.exports = __webpack_public_path__ + "img/album17_21.d41c4444.jpg";